import { Typography } from '@material-ui/core';
import moment from 'moment-timezone';
import React, { FC, useEffect, useState } from 'react';

type ClockProps = {
  timezone: string;
};

const Clock: FC<ClockProps> = (props: ClockProps) => {
  const getTime = () =>
    moment()
      .tz(props.timezone)
      .format('HH:mm A');
  const [time, setTime] = useState<string>(getTime());

  useEffect(() => {
    setInterval(() => {
      setTime(getTime());
    }, 1000);
    // eslint-disable-next-line
  }, []);
  return <Typography variant="h6">{time}</Typography>;
};

export default Clock;
